import { render, staticRenderFns } from "./AbnormalNoticeDetail.vue?vue&type=template&id=11f9bff4&scoped=true&"
import script from "./AbnormalNoticeDetail.vue?vue&type=script&lang=js&"
export * from "./AbnormalNoticeDetail.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalNoticeDetail.vue?vue&type=style&index=0&id=11f9bff4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f9bff4",
  null
  
)

export default component.exports